import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';

const styles = () => ({
    displayFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    verticalSpace: {
        margin: '25px 50px 20px 100px',
    },
    searchButtonSpace: {
        margin: '25px 50px 20px 100px',
    },
    clearButtonSpace: {
        margin: '25px 50px 20px 20px',
    },
});

const SearchButton = withCookies((props) => {
    const {
        classes,
        requestStartDate,
        requestEndDate,
        counselingKubunId,
        setData,
        state,
        cookies,
        chatTitle,
        addressNumber,
        nickName,
        setFullTextDisplayFlg,
        setIsLoading
    } = props;

    const setUserDatas = () => {
        setFullTextDisplayFlg(false);
        setIsLoading(true);
        setData([]);
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        const supportedPersonId = cookies.get('supportedPersonId');
        const availableAddress = cookies.get('AVAILABLE_ADDRESS') === 'TRUE' ? true : false;
        axios.post(
            `${Common.apiServerUrl()}/api/delivery/log`,
            {
                requestStartDate,
                requestEndDate,
                state: state.length !== 0 ? state : '',
                counselingKubunId: counselingKubunId.length !== 0 ? counselingKubunId : '',
                supportedPersonId: supportedPersonId,
                chatTitle,
                availableAddress,
                addressNumber,
                nickName
            },
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(res.result.length !== 0) setData(res.result);
                else window.alert('絞り込み条件に合致する結果が⾒つかりませんでした。');
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('MessageLogSearchButton.js SearchButton:get err:' + err.message);
        })
        .finally(()=> {
            setIsLoading(false);
        });
    };


    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => setUserDatas()}>検索</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

SearchButton.propTypes = {
    classes: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
    requestStartDate: PropTypes.string.isRequired,
    requestEndDate: PropTypes.string.isRequired,
    counselingKubunId: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    chatTitle: PropTypes.string.isRequired,
    setData: PropTypes.func.isRequired,
    setFullTextDisplayFlg: PropTypes.func.isRequired,
};

export default withStyles(styles)(SearchButton);